import gql from 'graphql-tag'

export const countUnreadNotification = gql`
  query CountUnreadNotification($workspaceId: Float!) {
    countUnreadNotification(workspace_id: $workspaceId) {
      countUnreadNotification
    }
  }
`
